import { ProductDumpApiContext } from 'components/common-form/contexts/ProductDumpContext';
import { useUserNotification } from 'hooks/useUserNotification';
import { useCallback, useContext, useState } from 'react';
import type { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { downloadZip } from 'utils/documents/downloadDocument';

export interface DownloadProductDumpAllApi {
  downloadProductDumpAll(pricingId: string): Observable<Blob>;
}

export const useProductDumpAll = (
  errorMessage = 'An error occurred while downloading product dump all. Please contact the support team if it persists.',
) => {
  const productDumpApi = useContext(ProductDumpApiContext)!;
  const [isProductDumpAllDownloading, setIsProductDumpAllDownloading] = useState(false);
  const userNotification = useUserNotification();

  const downloadProductDumpAll = useCallback(
    (pricingId: string) => {
      setIsProductDumpAllDownloading(true);
      const dump$: Observable<Blob> = productDumpApi.downloadProductDumpAll(pricingId).pipe(
        finalize(() => {
          setIsProductDumpAllDownloading(false);
        }),
      );
      dump$.subscribe({
        next(blob: Blob) {
          downloadZip(blob, `${pricingId}_productDump_all.zip`);
        },
        error() {
          userNotification.error({ title: { id: 'toast.export' }, content: [errorMessage] });
        },
      });
    },
    [productDumpApi, userNotification, errorMessage],
  );

  return {
    isProductDumpAllDownloading,
    downloadProductDumpAll,
  };
};
